"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PickerDialog = _interopRequireDefault(require("./PickerDialog"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ColorPicker = _ref => {
  let {
    // ColorPicker
    onChange,
    // Text field
    name,
    id,
    hintText,
    placeholder,
    floatingLabelText,
    label,
    TextFieldProps,
    value,
    defaultValue,
    ...custom
  } = _ref;
  const [showPicker, setShowPicker] = (0, _react.useState)(false);
  const [internalValue, setValue] = (0, _react.useState)(defaultValue);
  const convertToRGB = colorObject => {
    let returnVal = "";
    if (colorObject && colorObject.source === "rgb") {
      returnVal = "rgb(" + colorObject.rgb.r + "," + colorObject.rgb.g + "," + colorObject.rgb.b + "," + colorObject.rgb.a + ")";
    }
    return returnVal;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      name: name,
      id: id,
      label: floatingLabelText || label,
      placeholder: hintText || placeholder,
      onClick: () => setShowPicker(true),
      onChange: e => {
        setValue(e.target.value);
        onChange(e.target.value);
      },
      value: value === undefined ? internalValue : value,
      InputProps: {
        style: {
          color: value === undefined ? internalValue : value
        }
      },
      ...TextFieldProps,
      ...custom
    }), showPicker && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickerDialog.default, {
      value: value === undefined ? internalValue : value,
      onClick: () => {
        setShowPicker(false);
        onChange(value);
      },
      onChange: c => {
        setValue(c.source === "rgb" ? convertToRGB(c) : c.hex);
        onChange(c);
      }
    })]
  });
};
ColorPicker.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  hintText: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  floatingLabelText: _propTypes.default.string,
  TextFieldProps: _propTypes.default.shape(_TextField.default.propTypes),
  showPicker: _propTypes.default.bool,
  setShowPicker: _propTypes.default.func,
  internalValue: _propTypes.default.string,
  setValue: _propTypes.default.func
};
ColorPicker.defaultProps = {};
var _default = exports.default = ColorPicker;